import MuiMenu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import type { ReactNode } from "react";

export interface MenuOption {
  key: string;
  label: ReactNode;
  onSelect: () => void;
  disabled?: boolean;
}

export interface MenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  options: MenuOption[];
}

/** Presentational dropdown menu — pass an anchor element and option list. */
export function Menu({ anchorEl, open, onClose, options }: MenuProps) {
  return (
    <MuiMenu anchorEl={anchorEl} open={open} onClose={onClose}>
      {options.map((option) => (
        <MenuItem
          key={option.key}
          disabled={option.disabled}
          onClick={() => {
            option.onSelect();
            onClose();
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </MuiMenu>
  );
}
